import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import Hero from '../components/home/Hero';
import FeaturedProducts from '../components/home/FeaturedProducts';
import AboutSection from '../components/home/AboutSection';
import ServicesSection from '../components/home/ServicesSection';
import Testimonials from '../components/home/Testimonials';
import ContactCTA from '../components/home/ContactCTA';
import './HomePage.css';

const HomePage = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');
      const element = document.getElementById(id);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 100); // small delay to ensure DOM is ready
      }
    }
  }, [location]);

  return (
    <div className="home-page">
      <Hero />
      <div className="container">
        <AboutSection />
        <FeaturedProducts />
        <ServicesSection />
        <Testimonials />
        <ContactCTA />
      </div>
    </div>
  );
};

export default HomePage;
